import { PageHeader } from '../../components/PageHeader';
import { ClientesTable } from './components/ClientesTable';
import { useT } from '../../locales';

export function ClientesListPage() {
  const t = useT();
  return (
    <div>
      <PageHeader title={t('pages.clientes.title')} subtitle={t('pages.clientes.subtitle')} />
      <ClientesTable />
    </div>
  );
}
